import { Component } from '@angular/core';
import { EstablishmentActionService } from '../../services/establishments/establishment.action.service';
import { AddButtonComponent } from '../common/add-button/add-button.component';

@Component({
    selector: 'app-establishment-empty-state',
    templateUrl: './establishment-empty-state.component.html',
    styleUrl: './establishment-empty-state.component.scss',
    imports: [AddButtonComponent],
})
export class EstablishmentEmptyStateComponent {

    constructor(
        private readonly establishmentActionService: EstablishmentActionService,
    ) {
    }

    createEstablishment() {
        this.establishmentActionService.createEstablishment();
    }
}
